import { createHashRouter, Outlet, redirect } from 'react-router-dom';
import { ErrorBoundary } from 'src/modules/common/components/ErrorBoundary/ErrorBoundary';
import { HomePage } from 'src/actuators/home/HomePage.tsx';
import { ActuatorsListPage } from 'src/actuators/list/ActuatorsListPage.tsx';
import { ActuatorAccessoriesPage } from 'src/actuators/accessories/ActuatorAccessoriesPage.tsx';
import { PrefetchUserInput } from 'src/actuators/user-input/PrefetchUserInput.tsx';
import { PrefetchActuatorCheckout } from 'src/actuators/checkout/PrefetchActuatorCheckout.tsx';
import { SharePage } from 'src/actuators/SharePage.tsx';
import { PATHS } from 'src/actuators/common/types/Paths';
import { createChildrenRoute } from 'src/projects/createChildrenRoute.tsx';
import { RouteObject } from 'react-router/dist/lib/context';
import { PageLegacy } from 'src/actuators/common/PageLegacy.tsx';

const errorElement = <ErrorBoundary/>;

export const ActuatorRoutes: RouteObject[] = [
    {
        path: PATHS.Home,
        element: <HomePage/>,
        errorElement,
    },
    {
        path: PATHS.UserInput,
        element: <PrefetchUserInput/>,
        errorElement,
    },
    {
        path: `${PATHS.Actuators}/:page`,
        element: <PageLegacy pathname={PATHS.Actuators}/>,
        errorElement,
    },
    {
        path: PATHS.Actuators,
        element: <ActuatorsListPage/>,
        errorElement,
    },
    {
        path: `${PATHS.Accessories}/:actuatorLabel/:page`,
        element: <PageLegacy pathname={PATHS.Accessories}/>,
        errorElement,
    },
    {
        path: PATHS.Accessories,
        element: <ActuatorAccessoriesPage/>,
        errorElement,
    },
    {
        path: `${PATHS.Checkout}/:actuatorLabel/:page`,
        element: <PageLegacy pathname={PATHS.Checkout}/>,
        errorElement,
    },
    {
        path: PATHS.Checkout,
        element: <PrefetchActuatorCheckout/>,
        errorElement,
    },
];

export const router = () => createHashRouter([
    {
        path: '/',
        loader: () => redirect(PATHS.Home),
    },
    ...ActuatorRoutes.map((route) => ({
        ...route,
        element: <Outlet/>,
        children: createChildrenRoute(route.element),
    } as RouteObject)),
    {
        path: PATHS.Share,
        element: <SharePage/>,
        errorElement,
    },
    {
        path: '*',
        loader: () => redirect(PATHS.Home),
    },
]);
